import {
    ChangeDetectorRef,
    Component,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { RaskColumn } from "../models/rask-column";
import { FooterAggregationService } from "./footer-aggregation.service";

@Component({
    selector: "rask-footer-column",
    styleUrls: ["./footer-column.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./footer-column.component.html"
})
export class FooterColumnComponent implements OnInit, OnDestroy {
    @Input() column: RaskColumn;
    output = "";
    @Input() rows: any[];
    @HostBinding("style.width") width = "auto";

    private readonly aggrigationService = inject(FooterAggregationService);
    private readonly cdRef = inject(ChangeDetectorRef);
    private readonly destroy$ = new Subject<void>();

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.updateWidth();
        this.renderOutput();
        this.column.dataChanged.pipe(
            takeUntil(this.destroy$)
        ).subscribe(d => this.renderOutput());
    }

    renderOutput() {
        if (!ObjectUtils.hasValue(this.column.footerAgg) && !ObjectUtils.hasValue(this.column.footerText)) {
            return;
        }
        if (this.column.footerText) {
            this.output = this.column.footerText;
            return;
        }

        this.output = this.aggrigationService.runAggregation(this.column.footerAgg, this.rows, this.column.field);
    }

    updateWidth() {
        this.width = this.column
            ? `${this.column.renderedWidth}px`
            : "auto";
    }
}
